// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"9":"dicetray-world-offscreen","125":"dicetray-world-onscreen","696":"dicetray-world-none","869":"dicetray-dice-engine"}[chunkId] + ".bundle.js";
};